import React from 'react';
import { DecorCurve, type CurvePlacement, type CurveVariant } from './DecorCurve';
type Tone = 'navy' | 'royal' | 'mint' | 'white';
interface DecorPanelProps {
  tone?: Tone;
  /** `false` pour un bloc coloré sans motif. */
  curve?: false | {
    variant?: CurveVariant;
    placement?: CurvePlacement;
    className?: string;
  };
  className?: string;
  children: React.ReactNode;
}

/** Fond du bloc, et teinte du motif : toujours un cran plus clair que le fond. */
const tones: Record<Tone, string> = {
  navy: 'bg-ville-navy text-ville-blue',
  royal: 'bg-ville-blue text-white/15',
  mint: 'bg-ville-mist text-white/60',
  white: 'bg-white text-ville-mist'
};

/**
 * Bloc coloré portant le motif de courbe.
 *
 * Il impose `relative overflow-hidden` et empile correctement motif et contenu : posée
 * seule dans un parent sans `overflow-hidden`, la courbe déborde du bloc. Passer par ce
 * composant plutôt que par `DecorCurve` directement.
 */
export function DecorPanel({
  tone = 'navy',
  curve = {},
  className = '',
  children
}: DecorPanelProps) {
  return <div className={`relative isolate overflow-hidden ${tones[tone]} ${className}`} data-id="element-2861" data-mp="16m7o2ki6yw6j">
      {curve !== false && <span className="absolute inset-0 z-0" aria-hidden="true" data-id="element-2862" data-mp="1bj7tct77vuwl">
          <DecorCurve {...curve} data-id="element-2863" data-mp="1gcsrcl8t8ovs" />
        </span>}
      <div className="relative z-10" data-id="element-2864" data-mp="1kee0pwm4yl18">{children}</div>
    </div>;
}